import React from "react";

import "./TopGradient.css";

export default class TopGradient extends React.Component
{
    render () {
        return <div className="top-gradient" />;
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout/TopGradient.jsx